var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCrossSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1243 3.22364C12.787 2.55501 11.213 2.55501 9.87575 3.22364L5.87575 5.22364C4.28819 6.01741 3.17009 7.69271 3.44602 9.57132C3.78099 11.8519 4.5447 14.2829 5.72559 16.3849C6.90363 18.4818 8.5286 20.3057 10.6134 21.2791C11.4913 21.6891 12.5087 21.6891 13.3867 21.2791C15.4714 20.3057 17.0964 18.4818 18.2744 16.3849C19.4553 14.2829 20.219 11.8519 20.554 9.57132C20.8299 7.69271 19.7118 6.01741 18.1243 5.22364L14.1243 3.22364ZM15.5305 10.5303C15.8233 10.2374 15.8233 9.76256 15.5305 9.46967C15.2376 9.17678 14.7627 9.17678 14.4698 9.46967L11.0001 12.9394L9.53032 11.4697C9.23742 11.1768 8.76255 11.1768 8.46966 11.4697C8.17677 11.7626 8.17678 12.2375 8.46968 12.5303L10.4698 14.5304C10.7627 14.8232 11.2375 14.8232 11.5304 14.5304L15.5305 10.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCrossSolid);
export default __webpack_public_path__ + "static/media/shield-cross-solid.3945dbb6126cea2f78290cf3990adc62.svg";
export { ForwardRef as ReactComponent };